<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
        <a
          href="/enterprise/#/list?field=%E5%9C%A8%E7%BA%BF%E6%95%99%E8%82%B2&category=%E5%85%A8%E9%83%A8"
          target="_blank"
          >更多</a
        >
      </div>

      <Company />
    </div>

    <!-- <div class="right-box">
      <div class="right-title">
        <span>网课超市</span>
      </div>
      <div style="width: 300px">
        <a href="http://www.100ec.cn/edunav/" target="_blank">
          <img style="width: 100%" src="/Public/home/images/wkcs550.jpg" />
        </a>
      </div>
    </div> -->
    <!-- <div style="width: 365px;margin-bottom:20px" >
      <a
        href="https://www.med66.com/zhuanti/20230618/index.shtml"
        target="_blank"
      >
        <img style="width: 100%" src="https://www.100ec.cn/Public/home/images/jygg/550.jpg?v=1.0" />
      </a>
    </div> -->
    <!-- <div style="width: 365px">
      <a href="https://www.hqwx.com" target="_blank">
        <img style="width: 100%" src="https://www.100ec.cn/Public/Upload/image/20240604/1717481861904992.png" />
      </a>
    </div> -->

    <!-- <Email /> -->

    <!-- <div class="right-box">
      <div class="right-title">
        <span>合作伙伴</span>
      </div>
      <ul class="partner-list">
        <li>
          <a>
            <img
              src="//imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/aks.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/kid.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/hhsw.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/yfd.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/sdjg.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/zbyc.jpg?v=1.0"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/hqwxlogo.png"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/hxw.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/daw.png"
            />
          </a>
        </li>
      </ul>
    </div> -->

    <div class="right-box">
      <div class="right-title">
        <span>热门投诉</span>
        <a href="/Index/complain.html" target="_blank">我要投诉</a>
      </div>
      <ul class="platform">
        <li
          v-for="(i, index) of platform"
          :key="index"
          @click="getPlatform(index)"
        >
          {{ i }}
          <i class="fa fa-fire fa-lg"></i>
        </li>
      </ul>
    </div>
    <div class="right-box" style="width: 302px">
      <div class="right-title">
        <span>教育评测</span>
        <a
          href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E6%95%99%E8%82%B2%20%E8%AF%84%E6%B5%8B&cgy=zh"
          target="_blank"
          >更多>></a
        >
      </div>

      <div>
        <ul class="zx-list">
          <li v-for="(i, index) in information" :key="index">
            <a :href="'/detail--' + i.id + '.html'" target="_blank">
              {{ i.title }}</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div style="width: 365px">
        <img style="width: 100%" src="/Public/tuku/69d472ce7cec4.jpg" />
    </div>
    <!-- <div style="width: 365px; margin-top: 20px">
      <a>
        <img
          style="width: 100%"
          src="/Public/home/images/zyttk/zytgg/zxjyt.jpg"
        />
      </a>
    </div> -->
    <!-- <div class="right-box">
      <div class="right-title">
        <span>关注我们</span>
      </div>
      <div class="we-media">
        <a>
          <ul class="wx">
            <li>
              <div class="we-icon">
                <img :src="require('@/assets/wx.png')" />
                <span>网教宝</span>
              </div>
            </li>
            <img class="wx-show" :src="require('@/assets/wx-public.jpg')" />
            <li>微信公众号</li>
          </ul>
        </a>
        <a
          v-for="(i, index) of media"
          :key="index"
          :href="i.url"
          target="_blank"
        >
          <ul :class="i.icon">
            <li>
              <div class="we-icon">
                <img :src="require('@/assets/' + i.icon + '.png')" />
                <span>{{ i.we }}</span>
              </div>
            </li>
            <li>{{ i.name }}</li>
          </ul>
        </a>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      params: {
        field: "在线教育",
        tabs: [
          "综合",
          "职业教育",
          "早教",
          "语言类",
          "教育服务商",
          "高等教育",
          "steam教育",
          "K12",
          "MOOC",
        ],
      },
      year: "",
      time: "",
      platform: [],
      media: [],
      information: [],
    };
  },
  created() {
    this.$store.commit("getCompanyTabs", this.params);
  },
  mounted() {
    if (new Date().getMonth >= 2) {
      this.year = new Date().getFullYear();
    } else {
      this.year = new Date().getFullYear() - 1;
      this.time = "whole_year";
    }
    axios
      // http://www.315.100ec.cn/api/index.php?_a=product&f=most_company_list&type=7&year=2022&time=&limit=20
      .get(
        "https://www.100ec.cn/315/api/index.php?_a=product&f=most_company_list&type=7" +
          "&limit=20&year=" +
          this.year +
          "&time=" +
          this.time
      )
      .then((res) => {
        for (var i of res.data.list.slice(0, 10)) {
          this.platform.push(i.company);
        }
      });

    this.$store.state.dropList.forEach((item) => {
      if (item.name == "网教宝") {
        this.media = item.child;
      }
    });
    axios.get("/searchjson.html?p=1&n=6&terms=教育 评测").then((res) => {
      console.log(res);
      this.information = res.data.list;
    });
  },
  methods: {
    getPlatform(index) {
      window.open(
        "/Index/complain_search.html?company=" + this.platform[index]
      );
    },
  },
};
</script>

<style>
.partner-list li {
  padding: 10px;
  flex: 0 0 20%;
}
.partner-list img {
  width: 106px;
  border-radius: 2px;
  opacity: 1;
  transition: all 0.3s ease;
}
/* 资讯 */
.zx-list li {
  display: flex;
  font-size: 14px;
  color: #555;
  line-height: 40px;
  position: relative;
  padding-left: 2%;
}

.zx-list li::before {
  content: "";
  width: 6px;
  height: 6px;
  background: #ff6a04;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: calc(50% - 3px);
}

.zx-list li:hover a {
  color: #ff6a04;
}

.zx-list li a {
  font-size: 14px;
  color: #555;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-left: 10px;
  transition: all 0.5s ease-in-out;
}

.zx-list li p {
  color: #888;
}
</style>